document.addEventListener("DOMContentLoaded", function () {
    // Select the submit button
    const submitButton = document.querySelector('.mc4wp-form input[type="submit"]');
    
    if (submitButton) {
        // Create a new button element
        const newButton = document.createElement('button');
        newButton.type = 'submit';
        newButton.innerHTML = '&#8594;';
        newButton.style.background = "var(--wp--preset--color--base)";
        newButton.style.border = 'none';
        newButton.style.color = "var(--wp--preset--color--white)";
        newButton.style.fontSize = '18px';
        newButton.style.cursor = 'pointer';
        newButton.style.width = '36px';
        newButton.style.height = '36px';
        newButton.style.display = 'flex';
        newButton.style.alignItems = 'center';
        newButton.style.justifyContent = 'center';
        newButton.style.position = 'absolute';
        newButton.style.right = '6px';
        newButton.style.top = '3px';
        newButton.style.borderRadius = '50px';

        // Replace the input[type="submit"] with the new button
        submitButton.parentNode.replaceChild(newButton, submitButton);
    }
});
